import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n  z-index: 3;\n  position: absolute;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transform: translate3d(0, 0, 0); // Workaround for iOS safari bug\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  box-sizing: border-box;\n  border-radius: inherit;\n  height: 100%;\n  ", "\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  display: block;\n  position: relative;\n  box-sizing: border-box;\n  border-radius: inherit;\n  width: 100%;\n  height: 100%;\n  transform: translate3d(0, 0, 0); // Workaround for iOS safari bug\n  ", "\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { useCallback, useMemo } from 'react';
import styled from 'styled-components';
import { calculateActiveItemTranslateX, calculateNextIndex, calculatePreviousIndex, shouldShowLeftChevron, shouldShowRightChevron } from './helpers';
import ItemsCarouselDots from './components/ItemsCarouselDots';
import useCarouselSwipe from './hooks/useCarouselSwipe';
import useCarouselTap from './hooks/useCarouselTap';
import { ItemsCarouselLeftChevron, ItemsCarouselRightChevron } from './components/ItemsCarouselChevrons';
import { ItemsCarouselSlider } from './components/ItemsCarouselSlider';
import { $showMixin, heightMixin } from '../../mixins/layout';
import { NIGHTINGALE_BLACK } from '../../colors';
import CircleIconButton from '../../Button/CircleIconButton';
import { useCombineRefs, useHoverEvents, useIsClient, useMeasure, useMediaBreakpoints, useMouseHover, usePreventDrag, usePrevious } from '../../hooks';
import { combineByBreakpoints, EMPTY_FUNCTION, EMPTY_PROPS, getPx, styleArrayForBreakpoints, styleFlagForBreakpoints } from '../../helpers';
import { userSelectNoneStyle } from '../../tokens/user-select';
import { marginHorizontalHalfNegative } from '../../style';
var CAROUSEL_DOTS_OUTSIDE_BOTTOM_MARGIN = {
  xs: 32,
  md: 44,
  xl: 52
};
var CAROUSEL_DOTS_OUTSIDE_BOTTOM_POSITION = {
  xs: -24,
  md: -32,
  xl: -40
};
var CAROUSEL_DOTS_INSIDE_BOTTOM_POSITION = {
  xs: 16,
  md: 20,
  xl: 24
};
var CAROUSEL_DOTS_BACKDROP_HEIGHT = '30%';
var CarouselWrapper = styled.section(_templateObject(), function (_ref) {
  var $showDots = _ref.$showDots,
      $outsideDots = _ref.$outsideDots,
      $disabled = _ref.$disabled,
      $dotsOutsideBottomMargin = _ref.$dotsOutsideBottomMargin;
  return !$disabled ? styleArrayForBreakpoints([$showDots, $outsideDots, $dotsOutsideBottomMargin], function (_ref2) {
    var $showDots = _ref2[0],
        $outsideDots = _ref2[1],
        $bottomMargin = _ref2[2];
    return $showDots && $outsideDots ? "margin-bottom: " + getPx($bottomMargin) + ";" : '';
  }) : '';
}, function (_ref3) {
  var $pointer = _ref3.$pointer;
  return $pointer ? "cursor: pointer;" : '';
}, function (_ref4) {
  var $withUserSelectNone = _ref4.$withUserSelectNone;
  return styleFlagForBreakpoints($withUserSelectNone, userSelectNoneStyle);
}, heightMixin);
var CarouselInnerWrapper = styled.div(_templateObject2(), heightMixin, function (_ref5) {
  var $gutter = _ref5.$gutter;
  return marginHorizontalHalfNegative($gutter);
});
var CarouselDotsWrapper = styled.div(_templateObject3(), function (_ref6) {
  var $outsideDots = _ref6.$outsideDots,
      $outsidePosition = _ref6.$outsidePosition,
      $insidePosition = _ref6.$insidePosition;
  return styleArrayForBreakpoints([$outsideDots, $outsidePosition, $insidePosition], function (_ref7) {
    var $outsideDots = _ref7[0],
        $outsidePosition = _ref7[1],
        $insidePosition = _ref7[2];
    return $outsideDots ? "bottom: " + getPx($outsidePosition) + ";" : "bottom: " + getPx($insidePosition) + ";";
  });
}, $showMixin, function (_ref8) {
  var $disabled = _ref8.$disabled;
  return $disabled ? "display: none !important;" : '';
});

var GET_DOT_LABEL = function GET_DOT_LABEL(index, count) {
  return "Move to " + (index + 1) + " out of " + count;
};

var GET_ITEM_LABEL = function GET_ITEM_LABEL(index, count) {
  return index + 1 + " of " + count;
};

var ItemsCarousel = /*#__PURE__*/React.forwardRef(function (_ref9, forwardedRef) {
  var id = _ref9.id,
      _ref9$withNoEventsPro = _ref9.withNoEventsPropagation,
      withNoEventsPropagation = _ref9$withNoEventsPro === void 0 ? false : _ref9$withNoEventsPro,
      _ref9$withClickPreven = _ref9.withClickPrevention,
      withClickPrevention = _ref9$withClickPreven === void 0 ? true : _ref9$withClickPreven,
      _ref9$withUserSelectN = _ref9.withUserSelectNone,
      withUserSelectNone = _ref9$withUserSelectN === void 0 ? false : _ref9$withUserSelectN,
      _ref9$withDragPrevent = _ref9.withDragPrevention,
      withDragPrevention = _ref9$withDragPrevent === void 0 ? true : _ref9$withDragPrevent,
      _ref9$isAutoplayEnabl = _ref9.isAutoplayEnabled,
      isAutoplayEnabled = _ref9$isAutoplayEnabl === void 0 ? false : _ref9$isAutoplayEnabl,
      height = _ref9.height,
      onActiveItemIndexChange = _ref9.onActiveItemIndexChange,
      activeItemIndex = _ref9.activeItemIndex,
      chevronTopPosition = _ref9.chevronTopPosition,
      _ref9$chevronWidth = _ref9.chevronWidth,
      chevronWidth = _ref9$chevronWidth === void 0 ? 0 : _ref9$chevronWidth,
      _ref9$fullChevronsWid = _ref9.fullChevronsWidth,
      fullChevronsWidth = _ref9$fullChevronsWid === void 0 ? false : _ref9$fullChevronsWid,
      _ref9$withOutsideChev = _ref9.withOutsideChevrons,
      withOutsideChevrons = _ref9$withOutsideChev === void 0 ? false : _ref9$withOutsideChev,
      _ref9$showChevrons = _ref9.showChevrons,
      showChevrons = _ref9$showChevrons === void 0 ? false : _ref9$showChevrons,
      _ref9$showChevronsOnH = _ref9.showChevronsOnHover,
      showChevronsOnHover = _ref9$showChevronsOnH === void 0 ? false : _ref9$showChevronsOnH,
      _ref9$showDots = _ref9.showDots,
      showDots = _ref9$showDots === void 0 ? false : _ref9$showDots,
      _ref9$showDotsBackdro = _ref9.showDotsBackdrop,
      showDotsBackdrop = _ref9$showDotsBackdro === void 0 ? true : _ref9$showDotsBackdro,
      _ref9$outsideDots = _ref9.outsideDots,
      outsideDots = _ref9$outsideDots === void 0 ? true : _ref9$outsideDots,
      _ref9$dotsAmount = _ref9.dotsAmount,
      dotsAmount = _ref9$dotsAmount === void 0 ? 6 : _ref9$dotsAmount,
      _ref9$navigateOnClick = _ref9.navigateOnClick,
      navigateOnClick = _ref9$navigateOnClick === void 0 ? false : _ref9$navigateOnClick,
      _ref9$springConfig = _ref9.springConfig,
      springConfig = _ref9$springConfig === void 0 ? EMPTY_PROPS : _ref9$springConfig,
      _ref9$fullWidth = _ref9.fullWidth,
      fullWidth = _ref9$fullWidth === void 0 ? false : _ref9$fullWidth,
      overflowSpacingVertical = _ref9.overflowSpacingVertical,
      overflowSpacingHorizontal = _ref9.overflowSpacingHorizontal,
      _ref9$numberOfCards = _ref9.numberOfCards,
      numberOfCardsProp = _ref9$numberOfCards === void 0 ? 3 : _ref9$numberOfCards,
      _ref9$slidesToScroll = _ref9.slidesToScroll,
      slidesToScroll = _ref9$slidesToScroll === void 0 ? 1 : _ref9$slidesToScroll,
      _ref9$gutter = _ref9.gutter,
      gutter = _ref9$gutter === void 0 ? 0 : _ref9$gutter,
      _ref9$threshold = _ref9.threshold,
      threshold = _ref9$threshold === void 0 ? 0.25 : _ref9$threshold,
      _ref9$translateXMulti = _ref9.translateXMultiplier,
      translateXMultiplier = _ref9$translateXMulti === void 0 ? 1 : _ref9$translateXMulti,
      _ref9$disableSwipe = _ref9.disableSwipe,
      disableSwipe = _ref9$disableSwipe === void 0 ? false : _ref9$disableSwipe,
      _ref9$disableScrollOn = _ref9.disableScrollOnTouch,
      disableScrollOnTouch = _ref9$disableScrollOn === void 0 ? false : _ref9$disableScrollOn,
      _ref9$disableChangeOn = _ref9.disableChangeOnDotsClick,
      disableChangeOnDotsClick = _ref9$disableChangeOn === void 0 ? false : _ref9$disableChangeOn,
      _ref9$withOverflowHid = _ref9.withOverflowHidden,
      withOverflowHidden = _ref9$withOverflowHid === void 0 ? true : _ref9$withOverflowHid,
      _ref9$dotsBackdropHei = _ref9.dotsBackdropHeight,
      dotsBackdropHeight = _ref9$dotsBackdropHei === void 0 ? CAROUSEL_DOTS_BACKDROP_HEIGHT : _ref9$dotsBackdropHei,
      _ref9$disabled = _ref9.disabled,
      disabledInitialProp = _ref9$disabled === void 0 ? false : _ref9$disabled,
      onMouseOver = _ref9.onMouseOver,
      onMouseOut = _ref9.onMouseOut,
      _ref9$label = _ref9.label,
      label = _ref9$label === void 0 ? 'Carousel' : _ref9$label,
      _ref9$alignX = _ref9.alignX,
      alignX = _ref9$alignX === void 0 ? 'flex-start' : _ref9$alignX,
      _ref9$chevronButtonSi = _ref9.chevronButtonSizeVariant,
      chevronButtonSizeVariant = _ref9$chevronButtonSi === void 0 ? 'medium' : _ref9$chevronButtonSi,
      _ref9$leftChevronLabe = _ref9.leftChevronLabel,
      leftChevronLabel = _ref9$leftChevronLabe === void 0 ? 'Move back' : _ref9$leftChevronLabe,
      _ref9$leftChevronProp = _ref9.leftChevronProps,
      leftChevronProps = _ref9$leftChevronProp === void 0 ? EMPTY_PROPS : _ref9$leftChevronProp,
      _ref9$rightChevronLab = _ref9.rightChevronLabel,
      rightChevronLabel = _ref9$rightChevronLab === void 0 ? 'Move forward' : _ref9$rightChevronLab,
      _ref9$rightChevronPro = _ref9.rightChevronProps,
      rightChevronProps = _ref9$rightChevronPro === void 0 ? EMPTY_PROPS : _ref9$rightChevronPro,
      _ref9$getDotLabel = _ref9.getDotLabel,
      getDotLabel = _ref9$getDotLabel === void 0 ? GET_DOT_LABEL : _ref9$getDotLabel,
      _ref9$getDotProps = _ref9.getDotProps,
      getDotProps = _ref9$getDotProps === void 0 ? EMPTY_FUNCTION : _ref9$getDotProps,
      _ref9$getItemLabel = _ref9.getItemLabel,
      getItemLabel = _ref9$getItemLabel === void 0 ? GET_ITEM_LABEL : _ref9$getItemLabel,
      _ref9$getItemProps = _ref9.getItemProps,
      getItemProps = _ref9$getItemProps === void 0 ? EMPTY_FUNCTION : _ref9$getItemProps,
      _ref9$listProps = _ref9.listProps,
      listProps = _ref9$listProps === void 0 ? EMPTY_PROPS : _ref9$listProps,
      _ref9$infinite = _ref9.infinite,
      infinite = _ref9$infinite === void 0 ? false : _ref9$infinite,
      _ref9$dotsOutsideBott = _ref9.dotsOutsideBottomMargin,
      dotsOutsideBottomMargin = _ref9$dotsOutsideBott === void 0 ? CAROUSEL_DOTS_OUTSIDE_BOTTOM_MARGIN : _ref9$dotsOutsideBott,
      _ref9$dotsOutsideBott2 = _ref9.dotsOutsideBottomPosition,
      dotsOutsideBottomPosition = _ref9$dotsOutsideBott2 === void 0 ? CAROUSEL_DOTS_OUTSIDE_BOTTOM_POSITION : _ref9$dotsOutsideBott2,
      _ref9$dotsInsideBotto = _ref9.dotsInsideBottomPosition,
      dotsInsideBottomPosition = _ref9$dotsInsideBotto === void 0 ? CAROUSEL_DOTS_INSIDE_BOTTOM_POSITION : _ref9$dotsInsideBotto,
      children = _ref9.children,
      props = _objectWithoutPropertiesLoose(_ref9, ["id", "withNoEventsPropagation", "withClickPrevention", "withUserSelectNone", "withDragPrevention", "isAutoplayEnabled", "height", "onActiveItemIndexChange", "activeItemIndex", "chevronTopPosition", "chevronWidth", "fullChevronsWidth", "withOutsideChevrons", "showChevrons", "showChevronsOnHover", "showDots", "showDotsBackdrop", "outsideDots", "dotsAmount", "navigateOnClick", "springConfig", "fullWidth", "overflowSpacingVertical", "overflowSpacingHorizontal", "numberOfCards", "slidesToScroll", "gutter", "threshold", "translateXMultiplier", "disableSwipe", "disableScrollOnTouch", "disableChangeOnDotsClick", "withOverflowHidden", "dotsBackdropHeight", "disabled", "onMouseOver", "onMouseOut", "label", "alignX", "chevronButtonSizeVariant", "leftChevronLabel", "leftChevronProps", "rightChevronLabel", "rightChevronProps", "getDotLabel", "getDotProps", "getItemLabel", "getItemProps", "listProps", "infinite", "dotsOutsideBottomMargin", "dotsOutsideBottomPosition", "dotsInsideBottomPosition", "children"]);

  var items = useMemo(function () {
    return React.Children.toArray(children);
  }, [children]);
  var numberOfCards = useMediaBreakpoints(numberOfCardsProp);
  var disabledProp = useMediaBreakpoints(disabledInitialProp);
  var disabled = disabledProp || items.length <= numberOfCards;

  var _useMeasure = useMeasure(),
      setMeasureRef = _useMeasure.setRef,
      bounds = _useMeasure.bounds;

  var containerWidth = bounds.width;
  var isFirstScroll = !shouldShowLeftChevron({
    infinite: infinite,
    activeItemIndex: activeItemIndex,
    numberOfChildren: items.length,
    numberOfCards: numberOfCards,
    slidesToScroll: slidesToScroll
  });
  var isLastScroll = !shouldShowRightChevron({
    infinite: infinite,
    activeItemIndex: activeItemIndex,
    numberOfChildren: items.length,
    numberOfCards: numberOfCards,
    slidesToScroll: slidesToScroll
  });
  var previousActiveItemIndex = usePrevious(activeItemIndex);
  var nextItemIndex = calculateNextIndex({
    infinite: infinite,
    activeItemIndex: activeItemIndex,
    numberOfCards: numberOfCards,
    slidesToScroll: slidesToScroll,
    numberOfChildren: items.length
  });
  var previousItemIndex = calculatePreviousIndex({
    infinite: infinite,
    activeItemIndex: activeItemIndex,
    numberOfCards: numberOfCards,
    slidesToScroll: slidesToScroll,
    numberOfChildren: items.length
  });
  var activeItemTranslateX = calculateActiveItemTranslateX({
    infinite: infinite,
    activeItemIndex: activeItemIndex,
    numberOfCards: numberOfCards,
    containerWidth: containerWidth,
    numberOfChildren: items.length
  });
  var moveNext = useCallback(function () {
    return onActiveItemIndexChange(nextItemIndex);
  }, [nextItemIndex, onActiveItemIndexChange]);
  var movePrevious = useCallback(function () {
    return onActiveItemIndexChange(previousItemIndex);
  }, [previousItemIndex, onActiveItemIndexChange]);

  var _useHoverEvents = useHoverEvents(onMouseOver, onMouseOut),
      hoverRef = _useHoverEvents.ref,
      isHovered = _useHoverEvents.isHovered,
      handleMouseOver = _useHoverEvents.onMouseOver,
      handleMouseOut = _useHoverEvents.onMouseOut;

  var _useCarouselTap = useCarouselTap({
    onActiveItemIndexChange: onActiveItemIndexChange,
    nextItemIndex: nextItemIndex,
    previousItemIndex: previousItemIndex,
    navigateOnClick: navigateOnClick,
    disabled: disabled
  }),
      setTapRef = _useCarouselTap.setTapRef;

  var _useCarouselSwipe = useCarouselSwipe({
    containerWidth: containerWidth,
    numberOfCards: numberOfCards,
    onActiveItemIndexChange: onActiveItemIndexChange,
    activeItemIndex: activeItemIndex,
    threshold: threshold,
    items: items,
    translateXMultiplier: translateXMultiplier,
    disableSwipe: disableSwipe,
    disableScrollOnTouch: disableScrollOnTouch,
    disabled: disabled,
    withNoEventsPropagation: withNoEventsPropagation,
    withClickPrevention: withClickPrevention
  }),
      setSwipeRef = _useCarouselSwipe.setSwipeRef,
      touchRelativeX = _useCarouselSwipe.touchRelativeX;

  var _useMouseHover = useMouseHover(handleMouseOver, handleMouseOut, hoverRef),
      setHoverRef = _useMouseHover.setRef;

  var _usePreventDrag = usePreventDrag(null, !withDragPrevention, false),
      setPreventDragRef = _usePreventDrag.setRef;

  var minVisibleItemIndex = Math.min(activeItemIndex, Math.max(items.length - Math.ceil(numberOfCards), 0));
  var maxVisibleItemIndex = activeItemIndex + Math.ceil(numberOfCards) - 1; // visual properties

  var showBackdrop = useMemo(function () {
    return showDots === false || showDotsBackdrop === false || outsideDots === true ? false : showDots === true && showDotsBackdrop === true && outsideDots === false ? true : combineByBreakpoints([showDots, outsideDots, showDotsBackdrop], function (_ref10) {
      var showDots = _ref10[0],
          outsideDots = _ref10[1],
          showDotsBackdrop = _ref10[2];
      return showDots && !outsideDots && showDotsBackdrop;
    });
  }, [showDots, outsideDots, showDotsBackdrop]);
  var canShowChevrons = useMemo(function () {
    return disabledInitialProp === true || showChevrons === false ? false : combineByBreakpoints([showChevrons, showChevronsOnHover, numberOfCardsProp, disabledInitialProp], function (_ref11) {
      var showChevrons = _ref11[0],
          showChevronsOnHover = _ref11[1],
          numberOfCards = _ref11[2],
          disabledProp = _ref11[3];
      var disabled = disabledProp || items.length <= numberOfCards;
      return (showChevrons || showChevronsOnHover) && !disabled;
    });
  }, [showChevrons, showChevronsOnHover, items, disabledInitialProp, numberOfCardsProp]);
  var animate = useMemo(function () {
    return showChevronsOnHover === false || showChevrons === true ? false : combineByBreakpoints([showChevrons, showChevronsOnHover], function (_ref12) {
      var showChevrons = _ref12[0],
          showChevronsOnHover = _ref12[1];
      return !showChevrons && showChevronsOnHover;
    });
  }, [showChevrons, showChevronsOnHover]);
  var showRightChevron = isLastScroll ? false : canShowChevrons;
  var showLeftChevron = isFirstScroll ? false : canShowChevrons;
  var setWrapperRef = useCombineRefs(forwardedRef, setHoverRef, setTapRef, setSwipeRef);
  var setInnerWrapperRef = useCombineRefs(setPreventDragRef, setMeasureRef);

  var _useIsClient = useIsClient("carousel" + (id ? "-" + id : '')),
      key = _useIsClient.key;

  return /*#__PURE__*/React.createElement(CarouselWrapper, _extends({
    id: id,
    "aria-roledescription": "carousel",
    "aria-label": label,
    ref: setWrapperRef,
    $height: height,
    $pointer: !disabled && navigateOnClick,
    $showDots: showDots,
    $disabled: disabled,
    $outsideDots: outsideDots,
    $dotsOutsideBottomMargin: dotsOutsideBottomMargin,
    $withUserSelectNone: withUserSelectNone
  }, props), /*#__PURE__*/React.createElement(CarouselInnerWrapper, {
    $height: height,
    $gutter: gutter,
    ref: setInnerWrapperRef
  }, /*#__PURE__*/React.createElement(ItemsCarouselSlider, {
    id: id ? id + "-items" : null,
    enabled: containerWidth > 0,
    height: height,
    items: items,
    alignX: alignX,
    showBackdrop: showBackdrop,
    gutter: gutter,
    numberOfCards: numberOfCardsProp,
    numberOfChildren: items.length,
    withOverflowHidden: withOverflowHidden,
    overflowSpacingVertical: overflowSpacingVertical,
    overflowSpacingHorizontal: overflowSpacingHorizontal,
    dotsBackdropHeight: dotsBackdropHeight,
    minVisibleItemIndex: minVisibleItemIndex,
    maxVisibleItemIndex: maxVisibleItemIndex,
    isAutoplayEnabled: isAutoplayEnabled,
    getItemLabel: getItemLabel,
    getItemProps: getItemProps,
    listProps: listProps,
    disabled: disabled,
    fromTranslateX: activeItemTranslateX,
    toTranslateX: activeItemTranslateX + touchRelativeX,
    initialTranslateX: numberOfCards === 1 ? activeItemIndex * 100 + "%" : 0,
    config: springConfig,
    infinite: infinite,
    minDisplayIndex: activeItemIndex - Math.min(numberOfCards * 2, 6),
    maxDisplayIndex: activeItemIndex + numberOfCards - 1 + Math.min(numberOfCards * 2, 6)
  })), items.length > 1 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ItemsCarouselRightChevron, {
    key: key + "-right-chevron",
    $show: showRightChevron,
    $fullWidth: fullWidth,
    $alignX: fullChevronsWidth ? 'flex-end' : 'center',
    $width: chevronWidth,
    $topPosition: chevronTopPosition,
    $outside: withOutsideChevrons,
    $overflowSpacingVertical: overflowSpacingVertical,
    $slideIn: isHovered,
    $animate: animate
  }, /*#__PURE__*/React.createElement(CircleIconButton, _extends({
    role: "button",
    "aria-label": rightChevronLabel
  }, id ? {
    'aria-controls': id + "-items"
  } : {}, {
    sizeVariant: chevronButtonSizeVariant,
    hasArrow: true,
    arrow: 'right',
    iconColor: NIGHTINGALE_BLACK,
    noFocus: true,
    onClick: moveNext
  }, rightChevronProps))), /*#__PURE__*/React.createElement(ItemsCarouselLeftChevron, {
    key: key + "-left-chevron",
    $show: showLeftChevron,
    $fullWidth: fullWidth,
    $alignX: fullChevronsWidth ? 'flex-start' : 'center',
    $width: chevronWidth,
    $topPosition: chevronTopPosition,
    $outside: withOutsideChevrons,
    $overflowSpacingVertical: overflowSpacingVertical,
    $slideIn: isHovered,
    $animate: animate
  }, /*#__PURE__*/React.createElement(CircleIconButton, _extends({
    role: "button",
    "aria-label": leftChevronLabel
  }, id ? {
    'aria-controls': id + "-items"
  } : {}, {
    sizeVariant: chevronButtonSizeVariant,
    hasArrow: true,
    arrow: 'left',
    iconColor: NIGHTINGALE_BLACK,
    noFocus: true,
    onClick: movePrevious
  }, leftChevronProps))), /*#__PURE__*/React.createElement(CarouselDotsWrapper, {
    $outsideDots: outsideDots,
    $show: showDots,
    $disabled: disabled,
    $outsidePosition: dotsOutsideBottomPosition,
    $insidePosition: dotsInsideBottomPosition
  }, /*#__PURE__*/React.createElement(ItemsCarouselDots, {
    getDotLabel: getDotLabel,
    getDotProps: getDotProps,
    dotsAmount: dotsAmount,
    activeItemIndex: activeItemIndex,
    previousActiveItemIndex: previousActiveItemIndex,
    itemsAmount: items.length,
    disableChange: disableChangeOnDotsClick,
    onChange: onActiveItemIndexChange
  }))));
});
export default ItemsCarousel;